import React from 'react';
import Footer from '../../component/footer';
import Header from '../../component/header';
import About from '../about';
import Activities from '../activities';
import Contact from '../contact';
import Intro from './../intro';
import './style.css'

const Home=()=>{
    return(
        <div>
            <Header/>
            <Intro/>
            <About/>
            <Activities/>
            <Contact/>
            <Footer/>
        </div>
    )

}

export default Home